import React, { Component, Fragment } from 'react';
import HeaderComponent from '../../components/Header';
import '../../static/css/styles.css';
import SaayaLogo from '../../static/images/logo.svg';
import Footer from '../../components/Footer/footer';
import { constants } from '../../Constants';
import { FaqActions, alertActions, contactUsActions } from '../../store/actions';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import Loading from '../../components/Loading/Loading';
import { UnAuthenticatedHeader } from '../../components/HeaderUnAunthicated';
import './Faq.css';
class Faq extends Component {
	constructor(props) {
		super(props);
		this.state = {
			full_name: '',
			user_email: '',
			subject: '',
			description: '',
			message: '',
			responseType: '',
			loading: false,
			is_id_rcvd: false,
			faq_call_generated: false
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.showAlert = this.showAlert.bind(this);
	}
	componentWillMount() {
		this.props.clearAlertActions();
	}
	componentWillReceiveProps(nextProps) {
		const { message, responseType } = this.state;
		if (
			nextProps.whitelabel
			&& nextProps.whitelabel[0]
			&& nextProps.whitelabel
			&& nextProps.whitelabel[0].id
			&& !this.state.is_id_rcvd
			&& !this.state.faq_call_generated) {
			this.props.getFaqs(nextProps.whitelabel[0].id);
			this.setState({
				faq_call_generated: true
			})
		}
		nextProps && nextProps.faqs && this.setState({
			is_id_rcvd: true,
			faq_call_generated: false
		})
		if (nextProps.message !== '' && nextProps.responseType !== '') {
			if (nextProps.message !== message && nextProps.responseType !== responseType) {
				this.setState({
					message: nextProps.message,
					responseType: nextProps.responseType,
					loading: nextProps.loading,
				});
			}
		}
		this.setState({ loading: nextProps.loadingFaqs });
	}
	handleSubmit(ev) {
		ev.preventDefault();
		const { user } = this.props;
		const { subject, description, full_name, user_email } = this.state;
		this.setState({ submitted: true });
		if (subject === '' || description === '') {
			const message = constants.FILL_ALL_FIELDS_MSG;
			this.props.alertError(message);
		} else if (description.length < 10) {
			const message = constants.DESCRIPTION_LENGTH_ERROR_MSG;
			this.props.alertError(message);
		} else if (subject !== '' && description !== '') {
			if (user) {
				this.props.contactUs(user.full_name, user.user_email, subject, description);
				this.setState({ subject: '', description: '' });
			} else {
				if (full_name === '' || user_email === '') {
					const message = constants.FILL_ALL_FIELDS_MSG;
					this.props.alertError(message);
				} else if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(user_email))) {
					const message = constants.INVALID_EMAIL
					this.props.alertError(message);
				}
				else {
					this.props.contactUs(full_name, user_email, subject, description);
					this.setState({ full_name: '', user_email: '', subject: '', description: '' });
				}
			}
		}
	}
	handleChange(e) {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	}
	showAlert = () => {
		const { message, responseType } = this.state;
		if (message && message !== '' && responseType && responseType !== '') {
			this.props.clearAlertActions();

			Swal.fire('Saaya Health', message, responseType);
			this.setState({ message: '', responseType: '' });
			this.props.clearContactUs();
		}
	};
	render() {
		const { faqs, alert, loadingResponse, user } = this.props;
		const { loading } = this.state;

		if (loading || loadingResponse) return <Loading />;
		else {
			return (
				<div>
					{user ?
						<HeaderComponent />
						:
						<UnAuthenticatedHeader
							faq_active={true}
						/>
					}

					<div className="search-view-container">
						<p className="faq-heading1">{constants.FAQ_TEXT}</p>
						<p className="faq-heading2">{constants.HELP_TEXT}</p>
						<div className="form-label-group mt-2 mb-3 faq-input-div"></div>
					</div>
					<div className="question-form-div-container">
						<div className="top-question-div">
							<section class="faq-section">
								<div class="container">
									<div class="row">
										{faqs && faqs.length > 0 ? (
											<React.Fragment>
												<div class="col-md-8 offset-md-2">
													<div class="faq-title">
														<h2>{constants.TOP_QUESTIONS_TEXT}</h2>
													</div>
												</div>
												<div class="col-md-8 offset-md-2">
													<div class="faq" id="accordion">
														{faqs.map((f, i) => {
															return (
																<div class="card" id={`card${i}`} key={`card${i}`}>
																	<div class="card-header">
																		<div class="mb-0">
																			<h5
																				class="faq-title"
																				data-toggle="collapse"
																				data-target={`#faqCollapse-${i}`}
																				data-aria-expanded="true"
																				data-aria-controls={`faqHeading-${i}`}
																			>
																				{f.question}
																				<i
																					className="fa fa-angle-right faq-icon"
																					aria-hidden="true"
																				></i>
																			</h5>
																		</div>
																	</div>
																	<div
																		id={`faqCollapse-${i}`}
																		class="collapse"
																		aria-labelledby={`faqCollapse-${i}`}
																		data-parent="#accordion"
																	>
																		<div class="card-body">
																			<p>{f.answer}</p>
																		</div>
																	</div>
																</div>
															);
														})}
													</div>
												</div>
											</React.Fragment>
										) : (
											<div class="col-md-8 offset-md-2 text-center  mb-3 mt-0">
												<h2>{constants.FAQ_EMPTY_MSG}</h2>
											</div>
										)}
										<div className="col-md-8 offset-md-2">
											<div className="contact-us-form">
												<h2 className="contact-us-title">{constants.CONTACT_US_TEXT}</h2>
												{alert && alert.message ? (
													<div
														className={`alert text-center ${alert.type}`}
														id="errorMessage"
													>
														{alert.message}
													</div>
												) : (
													''
												)}
												{this.showAlert()}

												<div className="contact-us-input-form">
													{!user ? <Fragment>
														<input
															type="input"
															placeholder="Full Name"
															name="full_name"
															required
															value={this.state.full_name}
															onChange={this.handleChange}
															className="subject-input"
														></input>
														<input
															type="email"
															placeholder="Email Address"
															name="user_email"
															required
															value={this.state.user_email}
															onChange={this.handleChange}
															className="subject-input"
														></input>
													</Fragment> : ''}
													<input
														type="input"
														placeholder="Subject"
														name="subject"
														required
														value={this.state.subject}
														onChange={this.handleChange}
														className="subject-input"
													></input>
													<textarea
														type="input"
														placeholder="Description"
														name="description"
														onChange={this.handleChange}
														value={this.state.description}
														required
														className="description-input"
													></textarea>

													<button
														className="btn btn-lg btn-primary btn-block mt-4 mb-0 custom-btn"
														onClick={this.handleSubmit}
														type="submit"
													>
														{constants.SUBMIT_TEXT}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>
						</div>
					</div>
					<Footer />
				</div>
			);
		}
	}
}

function mapStateToProps(state) {
	const { session, auth, alert } = state;
	const { user } = auth;
	const { faqs, loadingFaqs } = state.faqs;
	const { whitelabel } = state.whitelabel;
	const { message, responseType, loadingResponse } = state.contactUs;
	return {
		user,
		session,
		whitelabel,
		faqs,
		alert,
		message,
		responseType,
		loadingFaqs,
		loadingResponse,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		getFaqs: (id) => {
			dispatch(FaqActions.fetchFaq(id));
		},
		clearAlertActions: () => {
			dispatch(alertActions.clear());
		},
		alertError: (message) => {
			dispatch(alertActions.error(message));
		},
		contactUs: (name, email, subject, body) => {
			dispatch(contactUsActions.contactUs(name, email, subject, body));
		},
		clearContactUs: () => dispatch(contactUsActions.clear()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Faq);



// WEBPACK FOOTER //
// ./src/screens/Faq/index.js